import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Auth';

export interface User {
  nombre: string;
  contraseña: string;
}

export class LoginAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	Login(user:User): AxiosPromise<any[]> {
		return this.cliente.post(user,`/Login`);
	}
}